import React, { forwardRef } from 'react'
import { Card, Form, DropdownButton, Button, Dropdown, OverlayTrigger, Popover, Row, Col } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import _ from 'lodash'

const AbsoluteTimePicker = ({
  dateRangeStart,
  dateRangeEnd,
  customStartInput,
  customEndInput,
  showTimeInput,
  shouldCloseOnSelect,
  disabled,
  yearDropdown,
  style,
  // methods
  setStartDate,
  setEndDate,
}) => {

  return (
    <Row>
      <Col className="pl-0 pr-0"  md={12}>
        <DatePicker
          selected            = {dateRangeStart}
          onChange            = {setStartDate}
          showTimeInput       = {showTimeInput}
          customInput         = {customStartInput}
          shouldCloseOnSelect = {shouldCloseOnSelect}
          disabled            = {disabled}
          style               = {style}
          yearDropdown        = {yearDropdown}
          required
          isClearable
        />
      </Col>
      <Col className="pl-0 pr-0"  md={12}>
        <DatePicker
          selected            = {dateRangeEnd}
          onChange            = {setEndDate}
          showTimeInput       = {showTimeInput}
          customInput         = {customEndInput}
          shouldCloseOnSelect = {shouldCloseOnSelect}
          disabled            = {disabled}
          style               = {style}
          yearDropdown        = {yearDropdown}
          required
          isClearable
        />
      </Col>
    </Row>
  )
};

export default AbsoluteTimePicker;
